import { create } from "zustand";

/**
 * Below the `lg` breakpoint (iPad portrait and smaller) the portal sidebar is a
 * slide-in drawer: the header's menu button opens it, picking a page / the
 * backdrop / Escape closes it. On `lg`+ the sidebar is always shown and this
 * state is ignored. One store for every portal — only one shell is mounted.
 */
interface SidebarDrawerState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useSidebarDrawerStore = create<SidebarDrawerState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));
